




































































import PaymentMethodAccordion from '@accounting/components/others/payment-method-accordion/payment-method-accordion.vue';
import { PaymentMethod } from '@accounting/interfaces/payment-method';
import ToolsHelper from '@core/services/tools.helper';
import TermsCheckbox from '@shared/components/forms/inputs/terms-checkbox/terms-checkbox.vue';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { ShoppingCartDiscount, ShoppingCartTicket } from '@accounting/interfaces/shopping-cart';

@Component({
  name: 'bpc-shopping-cart-wizard-payment-method-step',
  components: {
    'bpc-payment-method-accordion': PaymentMethodAccordion,
    'bpc-terms-checkbox': TermsCheckbox,
  },
})
export default class ShoppingCartWizardPaymentMethodStep extends Vue {
  @Prop({ type: Boolean, default: false }) readonly isFree: boolean;
  @Prop({ type: Number }) readonly amountToPay: number;
  @Prop({ type: Object, required: false }) readonly ticket: ShoppingCartTicket;

  get nextStepDisabled(): boolean {
    return !this.selectedPaymentMethod || this.nextStepAlreadyClicked;
  }

  showTermsAndConditionsMessage = false;

  // TODO check with Loic:
  // in case of not stripe payment, the structure could be different
  // maybe we should send only the string 'stripe', 'bancontact' etc.
  // in backend we can deduce the object structure based on that
  get selectedPaymentMethodObject(): PaymentMethod {
    const provider = this.selectedPaymentMethod;
    let providerDetail = this.selectedPaymentMethod;

    if (this.selectedPaymentMethod === 'stripe_card') {
      providerDetail = 'card';
    } else if (this.selectedPaymentMethod === 'stripe_bancontact') {
      providerDetail = 'bancontact';
    }

    return {
      provider: provider,
      provider_detail: providerDetail,
    };
  }

  termsAndConditionsChecked = false;
  selectedPaymentMethod = null;
  paymentMethodOptions = [];
  nextStepAlreadyClicked = false;

  public formatPrice(value) {
    return ToolsHelper.formatPrice(value);
  }

  public getDiscountVariant(discount: ShoppingCartDiscount): string {
    switch (discount.status) {
      case 'draft':
        return 'warning';
      case 'cancelled':
        return 'danger';
      case 'confirmed':
        return 'success';
      default:
        return 'primary';
    }
  }

  prevStepClicked() {
    this.$emit('previous-clicked');
  }
  nextStepClicked() {
    if (!this.termsAndConditionsChecked) {
      this.showTermsAndConditionsMessage = true;
    } else {
      this.nextStepAlreadyClicked = true;
      // check if payment method selected
      this.$emit('payment-method-selected', this.selectedPaymentMethodObject);
    }
  }

  @Watch('termsAndConditionsChecked')
  onTermsAndConditionsCheckedChange() {
    this.showTermsAndConditionsMessage = false;
  }
}
